export default __webpack_public_path__ + "static/media/img_11.2f4624d9.JPG";